<template>
  <highcharts
    :options="chartOptions" />
</template>

<script>
import {Chart} from 'highcharts-vue'

export default {
  name: 'Columns',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    },
    disableExpandDetails: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    chartOptions () {
      const _self = this
      return {
        chart: {
          type: 'column',
          height: 320,
          scrollablePlotArea: {
            minWidth: this.dataChart.series.length * 30 // 400
          },
          events: this.disableExpandDetails ? null : {
            click: function (event) {
              const point = this.series[0].searchPoint(event, true)
              _self.expand(point.index)
            }
          },
          style: this.disableExpandDetails ? null : {
            cursor: 'pointer'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          // min: 0,
          // max: 4,
          crosshair: true,
          type: 'category'
        },
        yAxis: {
          min: 0,
          title: {
            text: this.dataChart.metric_name
          },
          stackLabels: {
            enabled: true,
            cursor: 'pointer'
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: this.valueType
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            // borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: `{point.y}${this.valueType}`
            },
            cursor: this.disableExpandDetails ? null : 'pointer',
            point: this.disableExpandDetails ? null : {
              events: {
                click: (a) => {
                  this.expand(a.point.index)
                }
              }
            }
          }
        },
        legend: {
          enabled: false
        },
        series: [{
          name: this.dataChart.metric_name,
          colorByPoint: true,
          data: this.dataChart.series
          /* data: [
            {
              name: "Chrome",
              y: 62.74
            },
            {
              name: "Firefox",
              y: 10.57
            },
            {
              name: "Internet Explorer",
              y: 7.23
            }
          ] */
        }]
      }
    }
  },
  created () {
  },
  methods: {
    expand (index) {
      const serie = this.dataChart.series[index]
      this.$emit('expand', {
        filters: serie.filters,
        name: serie.name
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/Columns.vue